<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.userNum')}}</span>
        </div>
        <input class="e-input" :value='userNum' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox height-464">
      <div class="h-dialog-borderBox-topIcon">
        <div class="h-toolbarBg dialog-icon-style">
          <ejs-toolbar class="dialog-icon-style">
            <div class="dialog-icon-style" >
              <div>
                <button :title='$t("MCS.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style" data-ripple="true" tabindex="-1" @click='delBlack'>
                  <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
                </button>
              </div>
            </div>
          </ejs-toolbar>
        </div>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='index' width='30' textAlign='Center'></e-column>
            <e-column field='blackNum' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.blackList")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import commonJS from '../../common';
import DialogList from '../../../util/tipDialog/DialogList';
import CustomDialog from '../../../../common/CustomDialog';

export default {
  name: 'QryBlackDialog',
  props: [
    'neid'
  ],
  components: {
    DialogList,
    CustomDialog
  },
  mixins: [commonJS],
  data() {
    return {
      data: {},
      userNum: '',
      mcsid: '',
      page: {
        pageNo: '1',
        pageSize: '20',
        totalCount: '0',
        pageCount: '0',
      },
      vo: {
        flag: '',
        participantType: ''
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          {
            click: this.closeDialogListTipPage,
            buttonModel: { content: this.$t('MCS.confirm') }
          }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      }
    };
  },
  methods: {
    getGridData(mcsid = this.mcsid, userNum = this.userNum) {
      const $this = this;
      this.userNum = userNum;
      this.mcsid = mcsid;
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.qryBlackList
        },
        vo: {
          mcsid: this.mcsid[0],
          flag: 1
        },
        page: {
          pageNo: 1,
          pageSize: 100
        },
      };
      this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res;
      });
    },

    getGrid() {
      const gridData = this.$refs.grid.getSelectedRecords();
      if (gridData.length === 0) {
        this.$toast('warning', this.$t('Common.tips.noSelect'))
        return null;
      };
      const mcsid = [];
      gridData.forEach((item) => {
        mcsid.push(item.index);
      });
      return mcsid;
    },

    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },

    delBlack() {
      const $this = this;
      const mcid = this.getGrid();
      if (mcid === null) return;
      this.$layer.confirm({
        msg: this.$t('MCS.deleteConfirm'),
        btn1: {
          msg: this.$t('MCS.confirm'),
          func: () => {
            const userNum = [];
            this.$refs.grid.getSelectedRecords().forEach((item) => {
              userNum.push(item.blackNum);
            });
            const opCount = userNum.length;
            const resObj = [];
            for (let i = 0; i < opCount; i++) {
              const resData = {};
              resData.operObj = userNum[i];
              resObj.push(resData);
            };
            const logArray = [];
            userNum.forEach((numItem) => {
              logArray.push({
                userNum: $this.userNum,
                blackNum: numItem
              })
            });
            const params = {
              info: {
                neid: this.neid,
                msgid: this.msg.delBlackList,
              },
              vo: {
                opCount: opCount,
                index: this.getGrid()
              },
              log: {
                module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
                execFunName: 'subscriber.mcsDelBlack',
                exectype: 1,
                execData: logArray
              }
            };
            this.$axios.post('/lte/ems/subscriber/mcs/requestCommon', params).then((response) => {
              resObj.forEach((item, index) => {
                item.operResult = response.data.resultVal[index].display;
                item.operCode = response.data.resultVal[index].code;
              });
              this.$refs.dialog.addOperetionResultList(resObj);
              this.$refs.dialog.setTotalCount(opCount);
              this.$refs.dialogPage.show();
              this.getGridData();
            });
          }
        },
        btn2: {
          msg: this.$t('MCS.cancle')
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
